import Joi from 'joi';
  
    
export const VALIDATION_PARTICIPANTS_CREATE = {
    options: {allowUnknownBody: false},
    body: {
        name                                    : Joi.string(),
        participantType                         : Joi.string().valid("contractor", "user").required(),
        participantId                           : Joi.string().required(),
        projectId                               : Joi.string().required(),
        role                                    : Joi.string().required(),
        contacts                                : Joi.array().items(Joi.object()),
    }
};
    
    
export const VALIDATION_PARTICIPANTS_DELETE = {
    options: {allowUnknownBody: false},
    body: {
        participantType                         : Joi.string().valid("contractor", "user").required(),
        participantId                           : Joi.string().required(),
        projectId                               : Joi.string().required(),
    }
};
    
    
export const VALIDATION_PARTICIPANTS_LIST = {
    options: {allowUnknownBody: false},
    body: {
        projectId                               : Joi.string().required()
    }
};



// WEBPACK FOOTER //
// ./src/services/participant/Participant.Validator.js